import { TranslocoModule } from '@ngneat/transloco';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';

import { TranslationModule } from '@lib/translation';
import { SnBadgeModule } from '@lib/ui/badge';
import { SnIconModule } from '@lib/ui/icon';

import { SnMenuComponent } from './components';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    RouterModule,
    // Material
    MatMenuModule,
    // Libs
    SnIconModule,
    SnBadgeModule,
    TranslationModule,
    TranslocoModule,
  ],
  exports: [MatMenuModule, SnMenuComponent],
  declarations: [SnMenuComponent],
})
export class SnMenuModule {}
